import { render, staticRenderFns } from "./MercadoPago.vue?vue&type=template&id=2797afe8&scoped=true"
import script from "./MercadoPago.vue?vue&type=script&lang=js"
export * from "./MercadoPago.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2797afe8",
  null
  
)

export default component.exports